const IconFlight = props => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			className="flip-if-rlt"
		>
			<path
				d="M13.4203 1.46362C13.6778 1.45694 13.9592 1.52548 14.2826 1.71948C14.4804 2.04909 14.5493 2.33331 14.5424 2.59058C14.5352 2.85207 14.4489 3.12567 14.2767 3.42944C14.1557 3.64295 13.8286 4.03965 13.4213 4.48804C13.0276 4.92137 12.5982 5.36095 12.3129 5.64624L11.3129 6.64624L11.0824 6.87769L11.2006 7.18237L13.0453 11.9031C13.1442 12.3012 13.0568 12.7195 12.8109 13.0408L12.6937 13.1736L12.1498 13.7185L12.1439 13.7097L12.1371 13.7009L9.07458 9.37769L8.73181 8.89429L6.12634 11.4998L6.17517 11.7595L6.54626 13.7205L5.60095 14.6658L4.25232 11.9714L4.1781 11.822L4.02869 11.7478L1.33337 10.4001L2.27966 9.45288L4.2406 9.82495L4.50037 9.87378L7.10583 7.26831L6.62244 6.92554L2.29919 3.86401L2.28162 3.85229L2.82556 3.30835C3.15814 2.97583 3.64043 2.84308 4.09607 2.95581L8.81775 4.79956L9.12244 4.91772L9.35388 4.68726L10.3539 3.68726C10.6394 3.4018 11.0801 2.97292 11.515 2.57983C11.9652 2.17295 12.363 1.84634 12.5775 1.72632C12.8827 1.55562 13.1582 1.47046 13.4203 1.46362Z"
				fill="currentColor"
				stroke="currentColor"
			/>
		</svg>
	);
};

export default IconFlight;
